const SHOPIFY_SUFFIX = ".myshopify.com";
const STORE_SLUG_REGEX = /^[a-z0-9][a-z0-9-]*$/;

export const SHOPIFY_STORE_DOMAIN_REGEX =
  /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/;

/**
 * True only for a canonical "<slug>.myshopify.com" host.
 * Must gate every value that ends up in the host position of a URL we navigate
 * to — `shop` reaches us from user input and from Shopify callback query params.
 */
export const isShopifyStoreDomain = (
  value: string | null | undefined
): value is string => !!value && SHOPIFY_STORE_DOMAIN_REGEX.test(value);

// Accepts inputs like "jugl-dev", "jugl-dev.myshopify.com", or
// "https://jugl-dev.myshopify.com/" and returns the canonical
// "jugl-dev.myshopify.com" form (or null if it can't be coerced into one).
export const normalizeShopifyStoreDomain = (input: string): string | null => {
  let value = input.trim().toLowerCase();
  if (!value) return null;

  // Start/end chrome is already shown in the input — treat as empty slug, not an error
  if (/^https?:?\/?$/i.test(value) || /^\.?myshopify\.com\/?$/i.test(value)) {
    return null;
  }

  value = value.replace(/^https?:\/\//, "");
  value = value.replace(/\/.*$/, "");
  value = value.replace(/\.myshopify\.com\/?$/i, "");

  if (!value || !STORE_SLUG_REGEX.test(value)) return null;

  const normalized = `${value}${SHOPIFY_SUFFIX}`;
  return isShopifyStoreDomain(normalized) ? normalized : null;
};
